import { pageTitle } from 'ember-page-title';
import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';

<template>
  {{pageTitle (t "not_found.title") separator=" | "}}

  <section class="section not-found" aria-labelledby="not-found-title">
    <div class="container">
      <div class="not-found__code" aria-hidden="true">404</div>
      <h1 id="not-found-title" class="not-found__title">{{t
          "not_found.title"
        }}</h1>
      <p class="not-found__description">
        {{t "not_found.description"}}
      </p>
      <LinkTo @route="index" class="btn btn--outline">
        {{t "not_found.cta"}}
      </LinkTo>
    </div>
  </section>
</template>
